<div class="car-card-seller" >
  <div class="car-image">
    <div class = "image-container">
      @if (carImagesFolder?.length! < 1 && car.imagesFilenames?.length! > 0) {
        <p class="spinner">
          <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
        </p>
      }
      <img mat-card-image [src]="(currentImage != undefined) ? currentImage : 'assets/images/car_image_holder.webp'" alt="Car Image">
      <div class = "img-arrow-container">
        <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="prevImage();$event.stopPropagation()" class="pic-arrow-left"><mat-icon>arrow_back_ios</mat-icon></button>
        <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="nextImage();$event.stopPropagation()" class="pic-arrow-right"><mat-icon>arrow_forward_ios</mat-icon></button>
      </div>

      @if ((carImagesFolder != undefined && carImagesFolder!.length > 0)) {
        <div class = "img-counter">
          {{ currentImageIndex + 1 }}/{{ carImagesFolder!.length }}
        </div>
      }
    </div>
    <div class = "image-thumbs">

      @for (file of carImagesFolder  ; track file; let i = $index) {
        <div class="image-thumb"
          [style.border-color]=" (i===currentImageIndex) ? 'yellow': 'white'">
          <!-- <p class="spinner" *ngIf="carImagesFolder?.length! < 1 && car.imagesFilenames?.length! > 0">
          <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
        </p>  -->
        <!-- <img mat-card-image [src]= "(currentImage != undefined) ? currentImage : 'assets/images/car_image_holder.png'" alt="Car Image">
        -->
        <!-- <img src= "assets/images/car_image_holder.png" alt="Car Image"> -->
        <img mat-card-image
          [src]="(carImagesFolder.length! > 0) ? getImage(i) : 'assets/images/car_image_holder.png'" alt="Car Image"
          (click)="selectImage(i)"
          >
        </div>
      }
    </div>

    <div class="car-pic-upload">
      <label for="files" class="btn"> Ajouter photo </label>
      <input id="files" type="file" accept="image/*" multiple (change)="uploadImage(car.carId,$event); $event.stopPropagation()" />
    </div>

    <!-- <div class="seller-actions">
    <button class="cta-button"  mat-button (click)="openPriceDialog(car.carId) ;$event.stopPropagation()">Changer le Prix<mat-icon>attach_money</mat-icon></button>
  </div> -->

  <div class="car-infos">

    <div class="car-infos-block">

      <h4>{{car.make +" "+ car.model +" "+ car.version }}, {{car.year }}</h4>
      <h6><label>Moteur: </label>{{car.engine}}, {{car.fuel}}, {{car.gearBox }}, {{car.mileage}} KM - {{car.features}}</h6>

      <h6><label>Propriétaire:</label> {{car.ownerName}} , <label>Provider:</label> {{car.providerName }} </h6>
      <h6><label>Localisation:</label> {{car.city}}, {{car.country}}</h6>
      <h6><label>Postée / Dernière mis à jour:</label> {{dateFormat(car.created)}} / {{dateFormat(car.lastUpdated)}} - <label>Statut: </label> <b>{{car.status}} </b></h6>

    </div>
    <br />

    <mat-divider></mat-divider>

    <div class="car-infos-line">

      <div>
        <b> Provider Active &nbsp; </b>
        <mat-slide-toggle
          class="example-margin"
          [(ngModel)]="providerActive"

          [disabled]="false"
          (change)="updateProviderActiveStatus(car.carId, providerActive)">

        </mat-slide-toggle>
      </div>

      <div>
        <b>Provider sélectionné: </b>
        <button [disabled]="!providerActive" matButton class="simple-button"  mat-button (click)="openProviderDialog(car.carId);$event.stopPropagation()">
          <b> {{ car.providerId === '' ? 'no provider': car.providerId }}</b><mat-icon>edit</mat-icon>
        </button>

        <!-- <button matButton class="simple-button"  mat-button (click)="openRentPriceHistoryDialog(car.carId, carBusinessLine.RENT);$event.stopPropagation()">
        Historique <mat-icon>timeline</mat-icon>
      </button> -->
    </div>
  </div>

  <!--
  <div class="car-infos-line">

    <div>
      <b>En Vente &nbsp; </b>
      <mat-slide-toggle
        class="example-margin"
        [(ngModel)]="buyActive"

        [disabled]="false"
        (change)="updateBusinessLineStatus(car.carId, buyActive, CarBusinessLine.BUY)">

      </mat-slide-toggle>
    </div>
    <div>
      <b>Prix </b>
      <button [disabled]="! buyActive" matButton class="simple-button-buy"  mat-button (click)="openPriceDialog(car.carId, car.buyPrice.amount, CarBusinessLine.BUY );$event.stopPropagation()">
        <b>{{ moneyFormat(""+car.buyPrice?.amount) }} {{ car.buyPrice?.currency}} </b><mat-icon>edit</mat-icon>
      </button>
    </div>

    <button matButton class="simple-button-buy"  mat-button (click)="openBuyPriceHistoryDialog(car.carId, CarBusinessLine.BUY);$event.stopPropagation()">
      Historique <mat-icon>timeline</mat-icon>
    </button>
  </div>

  <div class="car-infos-line">
    <div>
      <b> En Location &nbsp; </b>
      <mat-slide-toggle
        class="example-margin"
        [(ngModel)]="rentActive"

        [disabled]="false"
        (change)="updateBusinessLineStatus(car.carId, rentActive, CarBusinessLine.RENT)">
      </mat-slide-toggle>
    </div>

    <div>
      <b>Tarif </b>
      <button [disabled]="!rentActive" matButton class="simple-button-rent"  mat-button (click)="openPriceDialog(car.carId, car.rentDayRate!.amount, CarBusinessLine.RENT );$event.stopPropagation()">
        <b> {{ moneyFormat(""+car.rentDayRate?.amount) }} {{car.rentDayRate?.currency}} /J</b><mat-icon>edit</mat-icon>
      </button>
    </div>
    <button matButton class="simple-button-rent"  mat-button (click)="openRentPriceHistoryDialog(car.carId, CarBusinessLine.RENT);$event.stopPropagation()">
      Historique <mat-icon>timeline</mat-icon>
    </button>

    <app-booking-edit
      [carId]="car.carId"
      [currentBookings]="car.allBookings">
    </app-booking-edit>

  </div> -->

  <mat-divider></mat-divider>
  <br />

  <div class="seller-actions">
    <!--
    <div>
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="View car details" (click)="goToCarDetailsPage(car.carId);$event.stopPropagation()">Détails<mat-icon>open_in_new</mat-icon></button>
    </div>

    <button *ngIf="isSeller" mat-button matTooltipPosition="above" matTooltip="Edit car details" (click)="goToCarEditPage(car.carId)" ><mat-icon>edit</mat-icon></button>
    -->

    @if ( ! (car.buyOffers.length > 0 || car.rentOffers!.length>0)) {
      <div>
        <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Delete" (click)="deleteCar(car.carId);$event.stopPropagation()" >
          Supprimer<mat-icon>delete</mat-icon>
        </button>
      </div>
    }

    <div>
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Update car details" (click)="openCarEditDialog();$event.stopPropagation()" >
        Editer<mat-icon>edit</mat-icon>
      </button>
    </div>

    <!--
    <div>
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Share">
        Partager<mat-icon>share</mat-icon>
      </button>
    </div>

    <div>
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Publish" (click)="updateCarStatus(car.carId, car.status);$event.stopPropagation()" >
        {{ getCarStatusAction(car.status) }} <mat-icon [style.color]="car.status === 'LISTED' ? '#008000':'#ff0000'"> {{ car.status === 'LISTED' ? 'public_off' : 'public' }}</mat-icon>
      </button>
    </div> -->
  </div>

  <!--
  <mat-divider></mat-divider>

  <div class="seller-actions">

    <div>
      <button class="cta-button-buy" mat-button matTooltipPosition="above" matTooltip="Update offer details" (click)="openProviderOfferDialog(car.carId, CarBusinessLine.BUY);$event.stopPropagation()" >
        Mettre en vente<mat-icon>add</mat-icon>
      </button>
    </div>

    <div>
      <button class="cta-button-rent" mat-button matTooltipPosition="above" matTooltip="Update offer details" (click)="openProviderOfferDialog(car.carId, CarBusinessLine.RENT);$event.stopPropagation()" >
        Mettre en location<mat-icon>add</mat-icon>
      </button>

    </div>
  </div>
  -->

</div>

</div>

<div class="car-data">

  <mat-accordion multi>

    @if (!isPosting) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Offres pour vente <span>({{car.buyOffers?.length}}) </span></h4>
            @if (canAddNewBuyOffer()) {
              <button
                class="simple-button-buy"  mat-button (click)="openNewProviderOfferDialog(CarBusinessLine.BUY);$event.stopPropagation()">
                <mat-icon>add</mat-icon> Nouvelle
              </button>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="car-data-section">
          <app-provider-offers
            [objectSource]="objectSource"
            [businessLine]="CarBusinessLine.BUY"
            [carId]="car.carId"
            [enableNew]="false">
          </app-provider-offers>
        </div>
      </mat-expansion-panel>
    }

    @if (!isPosting) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Offres pour location <span>({{car.rentOffers?.length}}) </span></h4>
            @if (canAddNewRentOffer()) {
              <button
                class="simple-button-rent"  mat-button (click)="openNewProviderOfferDialog(CarBusinessLine.RENT);$event.stopPropagation()">
                <mat-icon>add</mat-icon> Nouvelle
              </button>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="car-data-section">
          <app-provider-offers
            [objectSource]="objectSource"
            [businessLine]="CarBusinessLine.RENT"
            [carId]="car.carId"
            [enableNew]="false">
          </app-provider-offers>
        </div>
      </mat-expansion-panel>
    }

    @if (car.postings != undefined && isPosting) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Postings <span>({{car.postings.length}}) </span></h4>
            <button class="simple-button" mat-button (click)="openNewJobDialog(car.carId);$event.stopPropagation()">
              <mat-icon>add</mat-icon>Nouvelle
            </button>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if ((car.postings.length >= 0)) {
          <app-postings
            [objectSource]="objectSource"
            [carId]="car.carId"
            [enableNew]="false">
          </app-postings>
        }
      </mat-expansion-panel>
    }

    @if (car.jobs != undefined) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Jobs <span>({{car.jobs.length}}) </span></h4>
            <button class="simple-button" mat-button (click)="openNewJobDialog(car.carId);$event.stopPropagation()">
              <mat-icon>add</mat-icon>Nouvelle
            </button>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if ((car.jobs.length >= 0)) {
          <app-jobs
            [objectSource]="objectSource"
            [carId]="car.carId"
            [enableNew]="false"
            [potentialProviders]="currentDealer.favoriteProviderIds">
          </app-jobs>
        }
      </mat-expansion-panel>
    }

  </mat-accordion>
</div>
</div>
